"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = incomingActivity;
exports.INCOMING_ACTIVITY = void 0;
var INCOMING_ACTIVITY = 'DIRECT_LINE/INCOMING_ACTIVITY';
exports.INCOMING_ACTIVITY = INCOMING_ACTIVITY;

function incomingActivity(activity) {
  return {
    type: INCOMING_ACTIVITY,
    payload: {
      activity: activity
    }
  };
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9hY3Rpb25zL2luY29taW5nQWN0aXZpdHkuanMiXSwibmFtZXMiOlsiSU5DT01JTkdfQUNUSVZJVFkiLCJpbmNvbWluZ0FjdGl2aXR5IiwiYWN0aXZpdHkiLCJ0eXBlIiwicGF5bG9hZCJdLCJtYXBwaW5ncyI6Ijs7Ozs7OztBQUFBLElBQU1BLGlCQUFpQixHQUFHLCtCQUExQjs7O0FBRWUsU0FBU0MsZ0JBQVQsQ0FBMEJDLFFBQTFCLEVBQW9DO0FBQ2pELFNBQU87QUFDTEMsSUFBQUEsSUFBSSxFQUFFSCxpQkFERDtBQUVMSSxJQUFBQSxPQUFPLEVBQUU7QUFBRUYsTUFBQUEsUUFBUSxFQUFSQTtBQUFGO0FBRkosR0FBUDtBQUlEIiwic291cmNlUm9vdCI6ImNvcmU6Ly8vIiwic291cmNlc0NvbnRlbnQiOlsiY29uc3QgSU5DT01JTkdfQUNUSVZJVFkgPSAnRElSRUNUX0xJTkUvSU5DT01JTkdfQUNUSVZJVFknO1xuXG5leHBvcnQgZGVmYXVsdCBmdW5jdGlvbiBpbmNvbWluZ0FjdGl2aXR5KGFjdGl2aXR5KSB7XG4gIHJldHVybiB7XG4gICAgdHlwZTogSU5DT01JTkdfQUNUSVZJVFksXG4gICAgcGF5bG9hZDogeyBhY3Rpdml0eSB9XG4gIH07XG59XG5cbmV4cG9ydCB7IElOQ09NSU5HX0FDVElWSVRZIH07XG4iXX0=